/* eslint-disable react/jsx-pascal-case */

import { createPlaybackRecovery, ReconnectResult } from "../../../Component/ivs/playbackRecovery";
import { getIvsPlayerConfig } from "../../../Component/ivs/playerConfig";
import { createViewerAudioRecovery } from "./viewerAudioRecovery";
import {

  create,

  isPlayerSupported,

  LogLevel,

  PlayerEventType,

  PlayerState,

} from "amazon-ivs-player";

import axios from "axios";
import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";

import Live_End_Modal from "./modal/Live_End_Modal";

import Loader from "../../../Component/Loader";
import LiveHostStatus from "../../../Component/UI/LiveHostStatus";
import LivePlaybackButton from "../../../Component/UI/LivePlaybackButton";
import LiveSoundButton from "../../../Component/UI/LiveSoundButton";

import { mediaUrl } from "../../../Component/tool/mediaUrl";

import { restoreSession } from "../../../Component/axios_Interceptor/api";
import api2 from "../../../Component/axios_Interceptor/api2";

import url from "../../../Component/server";

import { live_info_type } from "./Live";

const getLiveInfoOptional = async (liveSeq: live_info_type["seq"], signal: AbortSignal) => {

  const token = await restoreSession();

  return axios.get(url.Communication_url.get_live_info, {
    signal,
    timeout: 10000,

    params: { seq: liveSeq },

    headers: token ? { Authorization: `Bearer ${token}` } : undefined,

  });

};


const VideoContainer = styled.div`

  position: absolute;

  width: 100%;

  height: 100%;

  box-sizing: border-box;

  overflow: hidden;



  video {

    height: 100%;

    width: 100%;

    object-fit: cover;

  }



  video::-webkit-media-controls,
  video::-webkit-media-controls-start-playback-button,
  video::-webkit-media-controls-overlay-play-button,
  video::-webkit-media-controls-timeline,

  video::-webkit-media-controls-current-time-display {

    display: none;

  }

`;



const WaitingScreen = styled.div`
  pointer-events: none;

  position: absolute;

  z-index: 1;

  inset: 0;

  display: flex;

  align-items: center;

  justify-content: center;

  overflow: hidden;

  background: #111111;

  color: #ffffff;



  &::after {

    position: absolute;

    inset: 0;

    background: rgba(0, 0, 0, 0.24);

    content: "";

  }



  img {

    width: 100%;

    height: 100%;

    object-fit: cover;

  }



`;

const WaitingInfo = styled.div`
  position: absolute;
  z-index: 1;
  right: 0;
  top: 45%;
  left: 0;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.6), transparent);
  text-align: center;
  pointer-events: none;

  strong {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.4;
  }

  span {
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
    line-height: 1.5;
  }
`;

const AccessDenied = styled.div`

  position: absolute;

  z-index: 70;

  inset: 0;

  display: flex;

  align-items: center;

  justify-content: center;

  flex-direction: column;

  gap: 8px;

  padding: 24px;

  box-sizing: border-box;

  background: #111111;

  color: #ffffff;

  text-align: center;



  strong { font-size: 20px; }

  span { color: rgba(255, 255, 255, 0.72); font-size: 14px; line-height: 1.5; }

`;



export type LivePlayerHandle = { unmute: (volume: number) => void };

interface LiveComponentProps {

  volume: number;
  onMutedChange?: (muted: boolean) => void;
  manage?: boolean;

  set_All_Visible?: (visible: boolean) => void;

  all_visible?: boolean;

  live_info: live_info_type;

  isAuthenticated?: boolean;
  integrationHostState?: { cameraMuted: boolean; micMuted: boolean };

  onPlaybackStarted?: (latencySeconds: number | (() => number), playbackTime?: () => number) => void;
  onPlaybackPaused?: () => void;
  // 송출앱이 Timed Metadata로 실어보내는 상품노출 이벤트 콜백(라이브커머스 상품팝업-영상 동기화,

  // 2026-07-16). 소켓 대신 영상 스트림에 실려오므로 시청자가 지금 보고 있는 화면(지연 포함)

  // 타이밍에 맞춰 도착한다. action은 원본 소켓 이벤트명과 동일("stock"|"stock_over") —

  // "Stock Over는 product_status가 판매노출일 때만 반영" 같은 조건 판단은 호출부에서 한다.

  on_product_metadata?: (action: "stock" | "stock_over", item: any, publishedAt?: number) => void;
}



const Network_Banner = styled.div`
  position: absolute;

  z-index: 56;
  top: 78px;
  left: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-sizing: border-box;
  min-height: 54px;
  padding: 12px 14px;
  border-radius: 4px;
  background: #ffffff;
  color: #333333;
  font-family: var(--font-Pretendard-Regular);
  font-size: 14px;
  line-height: 1.45;
  pointer-events: none;
`;

const Network_Spinner = styled.div`
  position: absolute;
  z-index: 54;
  inset: 0;
  pointer-events: none;
`;

const NetworkWarningIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
    <circle cx="8" cy="8" r="7" fill="#ffab00" />
    <path d="M8 4.2v4.6M8 11.4v.4" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);


const Live_Component = React.forwardRef<LivePlayerHandle, LiveComponentProps>(({
  volume,
  onMutedChange,
  manage,

  set_All_Visible,

  all_visible,

  live_info,

  isAuthenticated = false,

  onPlaybackStarted,

  onPlaybackPaused,
  on_product_metadata,
  integrationHostState,

}, ref) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const playerRef = useRef<any>(null);
  const audioRecoveryRef = useRef<ReturnType<typeof createViewerAudioRecovery> | null>(null);
  const mutedCallback = useRef(onMutedChange);
  mutedCallback.current = onMutedChange;
  const reportMuted = (muted: boolean) => {
    setIsMuted(muted);
    mutedCallback.current?.(muted);
  };
  React.useImperativeHandle(ref, () => ({
    unmute: (selectedVolume: number) => {
      const player = playerRef.current;
      if (!player) return;
      player.setVolume(selectedVolume / 100);
      player.setMuted(false);
      reportMuted(false);
    },
  }), []);
  const [isLoading, set_IsLoading] = useState<boolean>(true);
  const [isMuted, setIsMuted] = useState(false);

  const [hasPlayed, setHasPlayed] = useState(false);
  const [streamUnavailable, setStreamUnavailable] = useState(false);
  const [failedWaitingImage, setFailedWaitingImage] = useState<string | null>(null);
  const [playbackBlocked, setPlaybackBlocked] = useState(false);
  const [accessError, setAccessError] = useState("");



  // 송출앱의 Timed Metadata로 전달되는 유저 상황별 화면 상태.
  const [host_interrupted, set_Host_Interrupted] = useState(false);
  const [host_camera_off, set_Host_Camera_Off] = useState(false);
  const [hostCameraKnown, setHostCameraKnown] = useState(false);

  const [host_mic_muted, set_Host_Mic_Muted] = useState(false);
  useEffect(() => {
    if (!live_info.integration_test || !integrationHostState) return;
    setHostCameraKnown(true);
    set_Host_Camera_Off(integrationHostState.cameraMuted);
    set_Host_Mic_Muted(integrationHostState.micMuted);
  }, [live_info.integration_test, integrationHostState?.cameraMuted, integrationHostState?.micMuted]);

  const [network_unstable, set_Network_Unstable] = useState(false);
  const [player_rebuffering, set_Player_Rebuffering] = useState(false);
  const has_played_ref = useRef(false);
  const on_playback_started_ref = useRef(onPlaybackStarted);
  const on_playback_paused_ref = useRef(onPlaybackPaused);


  // 플레이어 mount 이펙트(아래, deps=[])는 한 번만 등록되므로 on_product_metadata를 직접

  // 클로저로 캡처하면 이후 리렌더로 prop이 바뀌어도 옛 함수를 계속 부르는 stale closure가 된다

  // — ref로 최신 값을 따로 동기화해 항상 최신 콜백을 호출한다.

  const on_product_metadata_ref = useRef(on_product_metadata);

  const is_authenticated_ref = useRef(isAuthenticated);

  useEffect(() => {

    on_product_metadata_ref.current = on_product_metadata;

  }, [on_product_metadata]);

  useEffect(() => {

    is_authenticated_ref.current = isAuthenticated;

  }, [isAuthenticated]);

  useEffect(() => {

    on_playback_started_ref.current = onPlaybackStarted;

    on_playback_paused_ref.current = onPlaybackPaused;
  }, [onPlaybackStarted, onPlaybackPaused]);


  const [live_end_modal, set_Live_End_Modal] = useState(false);

  const open_Live_End = () => set_Live_End_Modal(!live_end_modal);

  const checkEndedRef = useRef<() => Promise<boolean>>(async () => false);
  const serverEndedRef = useRef(false);
  const playbackFinishedRef = useRef(false);

  const finishEndedPlayback = React.useCallback((stalled = false) => {
    if (!serverEndedRef.current) return false;
    if (playbackFinishedRef.current) return true;
    const player = playerRef.current;
    const video = videoRef.current;
    let buffered = player?.getBufferDuration() ?? 0;
    if (video?.buffered.length) {
      buffered = Math.max(buffered, video.buffered.end(video.buffered.length - 1) - video.currentTime);
    }
    // A status update must never interrupt a viewer's buffered final frames.
    if (has_played_ref.current && player?.getState() !== PlayerState.ENDED && !video?.ended
        && !(stalled && buffered <= 0.1)) return false;
    playbackFinishedRef.current = true;
    audioRecoveryRef.current?.dispose();
    audioRecoveryRef.current = null;
    set_IsLoading(false);
    set_Player_Rebuffering(false);
    if (!manage) set_Live_End_Modal(true);
    return true;
  }, [manage]);


  // 방송 종료 감지 — IVS 플레이어 상태(ENDED/버퍼링 폴백)만으로는 종료를 놓치는 경우가 있어

  // (라이브 종료 시 ENDED 대신 에러/IDLE로 빠지거나, 버퍼링 타이머가 재생/버퍼링 반복으로 리셋됨).

  // 서버 종료를 확인하되 남은 영상은 유지하고, 재생 끝 또는 버퍼 소진 후 안내한다.

  // 값 계약(백엔드): 방송 중='방송중' / 종료='종료' / 예약='예약'.

  useEffect(() => {

    const live_seq = live_info?.seq;

    if (live_seq === undefined || live_seq === null) return;



    let stopped = false;

    let ended = false;
    let pending: Promise<boolean> | null = null;
    let intervalId: ReturnType<typeof setInterval> | undefined;
    const controller = new AbortController();
    const checkEnded = (): Promise<boolean> => {
      if (stopped || playbackFinishedRef.current || document.hidden) return Promise.resolve(ended);
      if (pending) return pending;
      pending = getLiveInfoOptional(live_seq, controller.signal).then(res => {
        if (stopped) return false;
        ended = !res.data?.integration_test && res.data?.live_status === "종료";
        serverEndedRef.current = ended;
        if (ended && finishEndedPlayback()) {
          clearInterval(intervalId);
        }

        return ended;
      }).catch(() => false).finally(() => { pending = null; });
      return pending;
    };

    checkEndedRef.current = checkEnded;
    const onVisibilityChange = () => {
      clearInterval(intervalId);
      if (document.hidden || playbackFinishedRef.current) return;
      void checkEnded();
      intervalId = setInterval(checkEnded, 5000);
    };
    if (!manage) {
      if (!document.hidden) intervalId = setInterval(checkEnded, 5000);
      document.addEventListener("visibilitychange", onVisibilityChange);
    }
    return () => {

      stopped = true;

      controller.abort();
      clearInterval(intervalId);

      document.removeEventListener("visibilitychange", onVisibilityChange);
      if (checkEndedRef.current === checkEnded) checkEndedRef.current = async () => false;
    };

  }, [manage, live_info?.seq, finishEndedPlayback]);



  useEffect(() => {

    if (!isPlayerSupported) {

      console.warn("현재 브라우저는 IVS 플레이어를 지원하지 않습니다.");

      return;

    }



    const player = create(getIvsPlayerConfig());


    player.setLogLevel(LogLevel.ERROR);

    // 저지연 모드 + 끊김(비행기모드/네트워크단절 등) 이후 라이브 끝단으로 강제 점프.

    // Let IVS manage live latency; reconnect only when playback stops making progress.
    // setInitialBufferDuration은 건드리지 않는다 — 이전 실험에서 역효과(지연시간 3.3초로 악화) 확인됨.

    player.setLiveLowLatencyEnabled(true);

    player.setRebufferToLive(true);

    playerRef.current = player;



    if (videoRef.current) {

      player.attachHTMLVideoElement(videoRef.current);

    }



    let disposed = false;
    let accessDenied = false;
    let streamInfoPending = false;
    const streamController = new AbortController();
    const getStreamInfo = async (canLoad = () => !disposed): Promise<ReconnectResult> => {
      if (accessDenied) return "stop";
      if (disposed || streamInfoPending || document.hidden || !canLoad()) return "retry";
      streamInfoPending = true;
      try {
        const token = is_authenticated_ref.current || manage ? await restoreSession() : null;
        if (!canLoad()) return "retry";
        const rehearsalInvite = new URLSearchParams(window.location.search).get("rehearsal_invite");
        const res = await api2.get(url.Communication_url.playback_info, {
          signal: streamController.signal,
          timeout: 10000,
          params: { live_seq: live_info?.seq, ...(rehearsalInvite ? { rehearsal_invite: rehearsalInvite } : {}) },
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        });
        if (serverEndedRef.current) return "stop";
        if (!canLoad() || !res.data?.playUrl) return "retry";
        setAccessError("");
        player.load(res.data.playUrl);
        return "loaded";
      } catch (err: any) {
        if (!canLoad()) return "retry";
        if (err?.response?.status === 403) {
          accessDenied = true;
          setAccessError(err.response.data?.message || "이 방송을 시청할 권한이 없습니다.");
          set_IsLoading(false);
          return "stop";
        }
        setStreamUnavailable(true);
        return "retry";
      } finally {
        streamInfoPending = false;
      }
    };

    const recovery = createPlaybackRecovery(player, async isCurrent => {
      if (audioRecoveryRef.current && !audioRecoveryRef.current.canReconnect()) return "retry";
      if (accessDenied) return "stop";
      const checkEnded = checkEndedRef.current;
      const ended = await checkEnded();
      if (!isCurrent() || checkEnded !== checkEndedRef.current) return "retry";
      if (ended) {
        return finishEndedPlayback(true) ? "stop" : "retry";
      }
      const canReconnect = () => isCurrent()
        && (!audioRecoveryRef.current || audioRecoveryRef.current.canReconnect());
      if (!canReconnect()) return "retry";
      if (!has_played_ref.current) setStreamUnavailable(true);
      set_IsLoading(true);
      if (has_played_ref.current) set_Player_Rebuffering(true);
      on_playback_paused_ref.current?.();
      return getStreamInfo(canReconnect);
    });
    void getStreamInfo();

    const audioRecovery = !manage && videoRef.current
      ? createViewerAudioRecovery(player, videoRef.current, () => {
          setPlaybackBlocked(true);
          set_IsLoading(false);
        })
      : null;
    audioRecoveryRef.current = audioRecovery;

    let mutedPlaybackRetried = false;
    const onPlaybackBlocked = () => {
      const recoveringAudio = audioRecovery?.playbackBlocked();
      setPlaybackBlocked(true);
      set_IsLoading(false);
      // A route change must not silently turn a previously audible stream mute.
      if (recoveringAudio) return;
      // Safari may require muted playback, or a gesture even when already muted.
      if (!mutedPlaybackRetried && !player.isMuted()) {
        mutedPlaybackRetried = true;
        player.setMuted(true);
        reportMuted(true);
        try { player.play(); } catch { /* Keep the explicit play button available. */ }
      }
    };
    const onReady = () => {
      mutedPlaybackRetried = false;
      try { player.play(); } catch { recovery.failed(); }
    };
    const onMutedChanged = () => reportMuted(player.isMuted());
    const onPlaying = () => {
      setStreamUnavailable(false);
      setPlaybackBlocked(false);
      recovery.playing();
      audioRecovery?.playing();
      onMutedChanged();
      if (!has_played_ref.current) {
        has_played_ref.current = true;
        setHasPlayed(true);
      }
      on_playback_started_ref.current?.(() => player.getLiveLatency(), () => player.getSyncTime());
      set_IsLoading(false);
      set_Player_Rebuffering(false);
    };
    const onEnded = () => {
      setStreamUnavailable(true);
      audioRecovery?.suspend();
      on_playback_paused_ref.current?.();
      set_IsLoading(true);
      recovery.failed();
      if (!finishEndedPlayback()) void checkEndedRef.current();
    };
    const onBuffering = () => {
      audioRecovery?.suspend();
      on_playback_paused_ref.current?.();
      set_IsLoading(true);
      if (has_played_ref.current) set_Player_Rebuffering(true);
      recovery.buffering();
    };
    // A 404 can also happen when an existing broadcast reconnects.
    const onError = () => {
      setStreamUnavailable(true);
      audioRecovery?.suspend();
      on_playback_paused_ref.current?.();
      set_IsLoading(true);
      recovery.failed();
    };

    // 송출앱의 카메라·마이크·인터럽트·네트워크 상태와 상품 이벤트를 수신한다.
    // 파싱 실패(다른 용도의 metadata 등)는 조용히 무시한다.
    const onMetadataCue = (cue: any) => {

      try {

        const data = JSON.parse(cue?.text ?? "");

        const metadata_value = (key: string) =>
          typeof data[key] === "boolean"
            ? data[key]
            : data.action === key && typeof data.value === "boolean"
              ? data.value
              : undefined;

        const host_interrupted = metadata_value("host_interrupted");
        if (host_interrupted !== undefined) {
          set_Host_Interrupted(host_interrupted);
        }

        const camera_muted = metadata_value("camera_muted");
        if (camera_muted !== undefined) {
          set_Host_Camera_Off(camera_muted);
          setHostCameraKnown(true);
        }

        const audio_muted = metadata_value("audio_muted");
        if (audio_muted !== undefined) set_Host_Mic_Muted(audio_muted);

        const network_unstable = metadata_value("network_unstable");
        if (network_unstable !== undefined) {
          set_Network_Unstable(network_unstable);
        }

        if (data.action === "stock" || data.action === "stock_over") {
          // 상품노출-영상 동기화(2026-07-16) — 소켓(Stock/Stock Over) 대신 이 이벤트로

          // 팝업을 띄우면, 쇼호스트가 말하는 그 영상 프레임과 같은 타이밍(지연 포함)에 도착한다.

          // 원본 이벤트 종류(action)와 데이터(item)를 그대로 넘겨, "Stock Over는 판매노출일

          // 때만 반영" 같은 기존 조건 판단은 호출부(Live.tsx)가 그대로 하도록 한다.

          on_product_metadata_ref.current?.(data.action, data.item, data.publishedAt);
        }

      } catch (e) {

        // 알 수 없는 형식의 metadata — 무시

      }

    };



    const onPaused = () => on_playback_paused_ref.current?.();
    player.addEventListener(PlayerState.IDLE, onPaused);
    player.addEventListener(PlayerState.READY, onReady);

    player.addEventListener(PlayerState.PLAYING, onPlaying);

    player.addEventListener(PlayerState.ENDED, onEnded);

    player.addEventListener(PlayerState.BUFFERING, onBuffering);

    player.addEventListener(PlayerEventType.ERROR, onError);
    player.addEventListener(PlayerEventType.MUTED_CHANGED, onMutedChanged);

    player.addEventListener(PlayerEventType.AUDIO_BLOCKED, onPlaybackBlocked);
    player.addEventListener(PlayerEventType.PLAYBACK_BLOCKED, onPlaybackBlocked);
    player.addEventListener(PlayerEventType.TEXT_METADATA_CUE, onMetadataCue);



    player.setVolume(volume / 100);



    return () => {
      disposed = true;
      audioRecovery?.dispose();
      audioRecoveryRef.current = null;
      recovery.dispose();
      streamController.abort();
      player.removeEventListener(PlayerState.IDLE, onPaused);
      player.removeEventListener(PlayerState.READY, onReady);

      player.removeEventListener(PlayerState.PLAYING, onPlaying);

      player.removeEventListener(PlayerState.ENDED, onEnded);

      player.removeEventListener(PlayerState.BUFFERING, onBuffering);

      player.removeEventListener(PlayerEventType.ERROR, onError);
      player.removeEventListener(PlayerEventType.MUTED_CHANGED, onMutedChanged);

      player.removeEventListener(PlayerEventType.AUDIO_BLOCKED, onPlaybackBlocked);
      player.removeEventListener(PlayerEventType.PLAYBACK_BLOCKED, onPlaybackBlocked);
      player.removeEventListener(PlayerEventType.TEXT_METADATA_CUE, onMetadataCue);

      player.delete();

    };

  }, []);



  useEffect(() => {

    if (playerRef.current) {

      playerRef.current.setVolume(volume / 100);

      playerRef.current.setMuted(volume === 0);

    }

  }, [volume]);


  const resumePlayback = () => {
    const player = playerRef.current;
    if (!player) return;
    player.setMuted(volume === 0);
    player.setVolume(volume / 100);
    reportMuted(volume === 0);
    player.play();
  };


  const Mute_Off = () => {

    playerRef.current.setMuted(false);

    playerRef.current.setVolume(volume / 100);
    reportMuted(false);
  };



  // console.log(playerRef.current && playerRef.current.getState());

  // console.log(playerRef.current && playerRef.current.getVolume());

  // console.log(playerRef.current && playerRef.current.isPaused());

  // console.log(playerRef.current && playerRef.current.isMuted());



  const liveStart = live_info.live_start?.trim().replace(" ", "T");
  const scheduledStart = liveStart
    ? new Date(/[zZ]$|[+-]\d{2}:?\d{2}$/.test(liveStart) ? liveStart : `${liveStart}+09:00`)
    : null;
  const scheduledStartLabel = scheduledStart && !Number.isNaN(scheduledStart.getTime())
    ? scheduledStart.toLocaleString("ko-KR", {
        timeZone: "Asia/Seoul", month: "long", day: "numeric",
        hour: "numeric", minute: "2-digit", hour12: true,
      })
    : null;

  const waitingImage = mediaUrl(live_info.live_img);
  const hostCameraPending = ["방송중", "리허설"].includes(live_info.live_status) && !hostCameraKnown;
  const waitingTitle = hostCameraPending
    ? streamUnavailable ? "방송 영상 연결 대기 중" : hasPlayed ? "방송 화면 확인 중" : "방송 연결 중"
    : "방송 대기 중";
  const showWaitingImage = !hostCameraPending && !!waitingImage && waitingImage !== failedWaitingImage;
  const hasHostStatus = host_interrupted || host_camera_off || host_mic_muted;
  const show_network_warning =
    !hasHostStatus && !playbackBlocked && (network_unstable || player_rebuffering);
  return (

    <VideoContainer translate="no" onClick={(event) => {
      if ((event.target as HTMLElement).closest('button, a, input, textarea, [role="dialog"], [role="alert"]')) return;
      if (playerRef.current?.isPaused()) resumePlayback();
      set_All_Visible?.(!all_visible);
    }}>

      {(!hasPlayed || hostCameraPending) && !accessError && <WaitingScreen>

        {showWaitingImage && <img src={waitingImage} alt="방송 대기 이미지" onError={() => setFailedWaitingImage(waitingImage)} />}
        {!playbackBlocked && <WaitingInfo role="status">
          {!showWaitingImage && <img src={require("../../../Image/Logo.png")} alt="팬버드" style={{width: 48, height: 48, objectFit: "contain", marginBottom: 8}} />}
          <strong>{waitingTitle}</strong>
          {hostCameraPending && streamUnavailable && <span>영상 신호가 도착하면 자동으로 재생됩니다.</span>}
          {!hostCameraPending && scheduledStartLabel && <span>시작 예정 · {scheduledStartLabel}</span>}
        </WaitingInfo>}
      </WaitingScreen>}

      {accessError && <AccessDenied role="alert"><strong>권한 부족</strong><span>{accessError}</span></AccessDenied>}

      {isLoading && !streamUnavailable && !playbackBlocked && !accessError && !show_network_warning && !hasHostStatus && <Loader />}
      {playbackBlocked && !accessError && <LivePlaybackButton onPlay={resumePlayback} />}
      <LiveSoundButton
        visible={all_visible !== true && volume > 0 && isMuted && !isLoading && !!playerRef.current && !playerRef.current.isPaused()}
        onUnmute={Mute_Off}
      />
      <video crossOrigin="anonymous"
        style={{ visibility: hostCameraPending || host_camera_off ? "hidden" : undefined }}
        controls={false}
        ref={videoRef}

        aria-label="라이브 영상"

        playsInline

      />

      {show_network_warning && (
        <>
          <Network_Banner role="status" aria-live="polite">
            <NetworkWarningIcon />
            <span>네트워크 상태가 불안정하여 버퍼링이 발생하고 있습니다.</span>
          </Network_Banner>
          <Network_Spinner role="status" aria-label="네트워크 버퍼링 중">
            <Loader />
          </Network_Spinner>
        </>
      )}

      <LiveHostStatus interrupted={host_interrupted} cameraOff={host_camera_off} micMuted={host_mic_muted} />
      <Live_End_Modal visible={live_end_modal} handleModal={open_Live_End} />

    </VideoContainer>

  );

});

export default Live_Component;
